module.exports = __webpack_public_path__ + "static/media/mangd.f53f0050.mp3";